// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"76":"48104595","124":"afc93b61","529":"8b34cf06","879":"2384535d"}[chunkId] + ".chunk.css";
};